/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: hao
 */

import { storedLanguage, deepClone } from '../../../utils'
import { apiMap, settings } from '../../../config/constants';
import { multiFetchApi, apiFetch } from '../../../apiClient';
import { installAOFormJsonTree2 as installAOFormJsonTree } from '../../../utils/AOFormJsonHandler2';
import { getSessionDatas, getCountryListFormLang } from '../../../utils'
// import application from './application.json'

export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const SAVE_APPINFO = "SAVE_APPINFO";
export const SAVE_RETRVINFO = "SAVE_RETRVINFO";
export const SAVE_BUSINESSINFO = "SAVE_BUSINESSINFO";
export const SAVE_SECTIONINFO = "SAVE_SECTIONINFO";
export const SAVE_COUNTRYLIST = "SAVE_COUNTRYLIST";
export const SAVE_INDUSTRYLEVELLIST = "SAVE_INDUSTRYLEVELLIST";
export const SHOW_LOADING = "SHOW_LOADING";
export const HANDLE_ERROR = "HANDLE_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const GET_APP_MESSAGE = "GET_APP_MESSAGE";
export const HANDLE_INPUTERROR = "HANDLE_INPUTERROR";
export const UPDATE_QIANHAI_INFO = "UPDATE_QIANHAI_INFO";
export const SAVE_STATUS = 'SAVE_STATUS';
export const SAVE_ALLCOUNTRYLIST = 'SAVE_ALLCOUNTRYLIST';
export const SAVE_RESORBUSOPESITCODELEVEL_LIST = 'SAVE_RESORBUSOPESITCODELEVEL_LIST';
export const changeLanguageAction = selectedLanguage => {
    return { type: CHANGE_LANGUAGE, selectedLanguage }
};
export const saveAppInfo = applicationInfo => {
    return { type: SAVE_APPINFO, applicationInfo }
};
export const saveRetrvInfo = retrvInfo => {
    return { type: SAVE_RETRVINFO, retrvInfo }
};
export const saveBusinessInfo = businessInfo => {
    return { type: SAVE_BUSINESSINFO, businessInfo }
};
export const saveSectionInfo = sectionInfo => {
    return { type: SAVE_SECTIONINFO, sectionInfo }
};
export const saveCountryList = (countryListDatas, lang) => {
    return { type: SAVE_COUNTRYLIST, countryListDatas, lang }
};
export const saveAllContryList = allCountryDatas => {
    return { type: SAVE_ALLCOUNTRYLIST, allCountryDatas }
};
export const saveIndustryLevelList = industryLevelList => {
    return { type: SAVE_INDUSTRYLEVELLIST, industryLevelList }
};
export const saveResOrBusOpeSitCodeLevelList = resOrBusOpeSitCodeLevelDatasRoots => {
    return { type: SAVE_RESORBUSOPESITCODELEVEL_LIST, resOrBusOpeSitCodeLevelDatasRoots }
};
export const menuAction = () => {
    return { type: TOGGLE_MENU }
};
export const showLoaing = (isDisplay) => {
    return { type: SHOW_LOADING, isDisplay }
};
export const handleError = (error) => {
    return { type: HANDLE_ERROR, error }
};

export const clearErrorAction = () => {
    return { type: CLEAR_ERROR }
}

export const getAppMessageAction = (data) => {
    return { type: GET_APP_MESSAGE, data }
}

export const updateQianhaiInfo = qianhaiInfo => {
    return { type: UPDATE_QIANHAI_INFO, qianhaiInfo }
}

export const saveStatus = (data) => ({
    type: SAVE_STATUS,
    data
});

export const clearError = () => dispatch => {
    dispatch(clearErrorAction())
}

export const handleInputError = (isDisplayInputErr, inputErrCode, errLocation) => {
    return { type: HANDLE_INPUTERROR, isDisplayInputErr, inputErrCode, errLocation }
};
/* istanbul ignore next */
export const changeLanguage = lang => dispatch => {
    storedLanguage(lang);
    dispatch(changeLanguageAction(lang))
};

export const getAppMessage = (url) => dispatch => {
    return apiFetch(apiMap.appI18n)(dispatch)
        .then(data => {
            dispatch(getAppMessageAction(data));
        })
        .catch(error => {
            throw error;
        });
}

/* istanbul ignore next */
export const retrvApp = (applicationId) => (dispatch) => {
    const retrvParams = {
        hostname: settings.hostnameApplication,
        method: settings.get
    };
    const businessParams = {
        hostname: settings.hostBusiness,
        method: settings.get
    };
    const sectionTemplateParams = {
        hostname: settings.hostnameSection,
        method: settings.get
    };
    const staticDataParams = {
        hostname: settings.hostnameStaticData,
        method: settings.get
    };
    dispatch(showLoaing(true));
    multiFetchApi([
        apiMap.retrvApp(applicationId),
        apiMap.getBusinessInfo(applicationId),
        apiMap.getSectionTemplate(getSessionDatas().intVersion, "CN"),
        apiMap.getStaticData(0)], [
            retrvParams,
            businessParams,
            sectionTemplateParams,
            staticDataParams])(dispatch)
        .then(([retrvResult, businessResult, sectionResult, staticDataResult]) => {
            dispatch(showLoaing(false));
            const retrvInfo = retrvResult.respBody;
            const businessInfo = businessResult.respBody;
            const sectionInfo = sectionResult.respBody;
            const retrvStaticData = JSON.parse(staticDataResult.respBody);
            const industryLevelList = retrvStaticData[1].roots;
            
            //const countryListCN = retrvStaticData[3].roots;
            let countryList;
            if(retrvStaticData[3]){
               countryList = [retrvStaticData[3].roots, retrvStaticData[0].roots]; 
            } else {
               countryList = [retrvStaticData[0].roots, retrvStaticData[0].roots];  
            }
            const countryListResult = getCountryListFormLang(countryList);

            let resOrBusOpeSitCodeLevelDatasRoots;
            if(retrvStaticData[4]){
                resOrBusOpeSitCodeLevelDatasRoots = retrvStaticData[4].roots;
            }
            // const resOrBusOpeSitCodeLevelDatasRoots = retrvStaticData[4].roots;
            dispatch(saveRetrvInfo(retrvInfo));
            dispatch(saveBusinessInfo(businessInfo));
            dispatch(saveSectionInfo(sectionInfo));
            dispatch(saveCountryList(countryList));
            dispatch(saveAllContryList(countryList));
            dispatch(saveResOrBusOpeSitCodeLevelList(resOrBusOpeSitCodeLevelDatasRoots));//RBBOB-15726 AC2
            dispatch(saveIndustryLevelList(retrvStaticData[1]));

            const newAppInfo = deepClone(retrvInfo);
            const newSectionInfo = deepClone(sectionInfo);
            newAppInfo.sections = newSectionInfo;
            installAOFormJsonTree(newAppInfo, businessInfo, countryListResult, industryLevelList, resOrBusOpeSitCodeLevelDatasRoots);
            newAppInfo.companyInfo = businessInfo.companyInfo;
            dispatch(saveAppInfo(newAppInfo));
        }).catch(error => {
            dispatch(showLoaing(false));
        });
};


export const getBusandqs = (appInfo, retrvInfo, countryList, industryLevelList, sectionInfo, resOrBusOpeSitCodeLevelDatasRoots) => dispatch => {
    const { applicationId } = getSessionDatas();
    const data = {
        hostname: settings.hostBusiness
    };
    dispatch(showLoaing(true))
    return apiFetch(apiMap.getBusinessInfo(applicationId), data)(dispatch)
        .then(res => {
            if (res.respCode === '200' && res.respBody) {
                const newAppInfo = deepClone(retrvInfo);
                const newSectionInfo = deepClone(sectionInfo);
                newAppInfo.sections = newSectionInfo;
                const businessInfo = res.respBody;
                const industryLevelListRoot = industryLevelList.roots;
                installAOFormJsonTree(newAppInfo, businessInfo, countryList, industryLevelListRoot, resOrBusOpeSitCodeLevelDatasRoots);
                newAppInfo.companyInfo = businessInfo.companyInfo;
                newAppInfo.status = appInfo.status
                newAppInfo.progressIndex = appInfo.progressIndex
                dispatch(saveBusinessInfo(businessInfo));
                dispatch(saveAppInfo(newAppInfo));
                dispatch(showLoaing(false));
                return res.respBody;
            } else {
                dispatch(showLoaing(false));
                return null;
            }
        })
        .catch(error => {
            dispatch(showLoaing(false));
            throw error;
        });
}


// WEBPACK FOOTER //
// ./src/views/App/state/action.js